import { render, staticRenderFns } from "./LoyaltyForm.vue?vue&type=template&id=308cb4a4&scoped=true&"
import script from "./LoyaltyForm.vue?vue&type=script&lang=js&"
export * from "./LoyaltyForm.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyForm.vue?vue&type=style&index=0&id=308cb4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308cb4a4",
  null
  
)

export default component.exports